import Container, { ContainerProps } from "./Container";
import styles from "./Container.module.scss";

export interface BorderContainerProps extends ContainerProps {
  incomplete?: boolean;
}

export default function BorderContainer({ incomplete, className, ...props }: BorderContainerProps) {
  return (
    <Container
      {...props}
      className={`${className} ${styles["border-container"]} ${
        incomplete ? styles.incomplete : ""
      }`}
    />
  );
}
